import { Component, effect, inject, OnInit, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, Subscription, switchMap } from 'rxjs';
import { IndexIoService } from '../../services/index-io.service';
import { ProgressSpinner } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'bnpp-indx-bloomberg-landing',
  imports: [ProgressSpinner, CommonModule],
  templateUrl: './bloomberg-landing.component.html',
  styleUrl: './bloomberg-landing.component.scss'
})
export class BloombergLandingComponent implements OnInit {
  private indexInfoService = inject(IndexIoService);
  bloombergCode = signal<string>('');
  private paramSubscription!: Subscription;
  protected productDetails = toSignal(
    toObservable(this.bloombergCode).pipe(
      filter((code) => code !== ''),
      switchMap((code) => {
        return this.indexInfoService.getProductDetailsByBloombergCode(code);
      })
    )
  );

  constructor(private route: ActivatedRoute, private router: Router) {
    effect(() => {
      const details = this.productDetails();
      if (details) {
        this.indexInfoService.saveProudctIdAndMdsCode(details);
        const pidEncoded = encodeURIComponent(details.ProductId ?? '');
        const subIdEncoded = encodeURIComponent(details.SubProductId ?? '');
        this.router.navigateByUrl(`/Strategy/Index?pid=${pidEncoded}&subid=${subIdEncoded}`)
      }
    })
  }
  ngOnInit(): void {
    // Subscribe to parameter changes
    this.paramSubscription = this.route.paramMap.subscribe(params => {
      this.bloombergCode.set(params.get('bloombergCode') ?? '');
    });
  }
}
